/**
 * Single entry point for the native JavaScript `eval` (kept until the operators used by the callers are identified).
 * Indirect eval `(0, eval)(…)` runs in the global scope: no access to the module scope, no esbuild `direct-eval` warning.
 */
export class EvalHelper {
  /** Evaluates `expression` with the native `eval`. Throws on invalid syntax, like `eval`. */
  static evaluate<T = unknown>(expression: string): T {
    // eslint-disable-next-line no-eval
    return (0, eval)(expression) as T;
  }
}
